import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Consultation } from "@customTypes/consultation";

import { consultationQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (Object.keys(res.data).length) {
    const newData = {} as Consultation;

    const {
      _id,
      c_id,
      aid,
      alcohol_consumption,
      blood_pressure,
      blood_type,
      consultation_method,
      consultation_service,
      consultation_type,
      created_at,
      date,
      diagnosis,
      diet,
      doctors_note,
      donor,
      examination,
      exercising_frequency,
      files,
      follow_up,
      height,
      location,
      occupation,
      observation,
      oxygen_saturation,
      patient_id,
      physician,
      pulse_rate,
      reason,
      respiratory_rate,
      smoking_habits,
      status,
      symptoms,
      temperature,
      treatment,
      updated_at,
      visibility,
      weight,
      appointment_id,
      cancellation_reason,
      recommendation,
    } = res.data;

    newData.id = _id;
    newData.cId = c_id;
    newData.consultationMethod = consultation_method;
    newData.consultationService = {
      id: consultation_service?._id,
      name: consultation_service?.name,
    };
    newData.consultationType = consultation_type;
    newData.supportStaff = aid?.map((item: any) => ({
      id: item._id,
      fullName: item.full_name,
    }));
    newData.bloodPressure = blood_pressure;
    newData.date = new Date(date);
    newData.diagnosis = diagnosis;
    newData.followUp = follow_up;
    newData.examination = examination;
    newData.files = files;
    newData.location = location;
    newData.doctorsNote = doctors_note;
    newData.observation = observation;
    newData.oxygenSaturation = oxygen_saturation;
    newData.patientId = patient_id;
    newData.physician = {
      id: physician._id,
      fullName: physician.full_name,
    };
    newData.pulseRate = pulse_rate;
    newData.reason = reason;
    newData.respiratoryRate = respiratory_rate;
    newData.smokingHabits = smoking_habits;
    newData.status = status;
    newData.symptoms = symptoms;
    newData.temperature = temperature;
    newData.treatment = treatment;
    newData.visibility = visibility;
    newData.drinkingHabits = alcohol_consumption;
    newData.bloodType = blood_type;
    newData.bloodDonor = donor;
    newData.diet = diet;
    newData.exerciseFrequency = exercising_frequency;
    newData.height = height;
    newData.weight = weight;
    newData.occupation = occupation;
    newData.createdAt = new Date(created_at);
    newData.updatedAt = new Date(updated_at);
    newData.appointmentId = appointment_id;
    newData.cancellationReason = cancellation_reason;
    newData.recommendation = recommendation;

    // console.log(newData);
    return newData;
  }
  return null;
};

interface QueryProps {
  consultationId: string;
  isEnabled?: boolean;
}

export const useGetSingleConsultation = ({
  consultationId,
  isEnabled = true,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: consultationQKeys.singleConsultation(consultationId),
    queryFn: () => api.get(`report/${consultationId}`),
    select,
    enabled: isEnabled,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Single Consultation]", res);
      handleErrors(res, "query");
    },
  });
};
